import React from 'react';
import { Card, CardContent } from './ui/card';
import { Clock, FileText, Palette, Sparkles, Edit, Lock } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      icon: <Palette className="h-8 w-8" />,
      title: 'Choose a Template',
      description: 'Select Sick Leave, Fitness, or General Medical Certificate template.'
    },
    {
      number: '2',
      icon: <Edit className="h-8 w-8" />,
      title: 'Fill in Details',
      description: 'Enter patient name, diagnosis, doctor details, and leave duration.'
    },
    {
      number: '3',
      icon: <FileText className="h-8 w-8" />,
      title: 'Preview Live',
      description: 'See the certificate update in real-time as you type. Edit directly if needed.'
    },
    {
      number: '4',
      icon: <Clock className="h-8 w-8" />,
      title: 'Download or Print',
      description: 'Download as PDF or print the certificate directly from your browser.'
    }
  ];

  return (
    <div className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* How It Works Section */}
        <div className="text-center mb-16">
          <p className="text-pink-600 font-semibold mb-2">Simple & Fast</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">How to Generate a Medical Certificate</h2>
          <p className="text-lg text-gray-600 mb-12">
            Create your certificate in under 2 minutes — completely free, no signup needed.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step) => (
              <Card key={step.number} className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="pt-6">
                  <div className="bg-pink-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    {step.icon}
                  </div>
                  <div className="text-3xl font-bold text-pink-600 mb-2">{step.number}</div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;